(function () {
  'use strict';

  const SELECTORS = {
    upsellForm: '.mublig-cart-upsell-card__form',
    upsellCard: '.mublig-cart-upsell-card',
    sidebarSubtotal: '.cart__sidebar .totals__subtotal-value',
    stickySubtotal: '.mublig-cart-sticky-checkout__total strong',
    mobilePreview: '.mublig-cart-mobile-preview',
    cartSidebar: '.cart__sidebar',
    stickyCheckout: '.mublig-cart-sticky-checkout',
    cartCount: [
      '.mublig-mobile-app-header__cart-count',
      '.cart-count-bubble',
      '[data-cart-count]',
      '.cart-count',
      '.header__cart-count'
    ].join(',')
  };

  function formatMoney(cents) {
    const value = (Number(cents || 0) / 100).toLocaleString('de-DE', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    });

    return '€' + value + ' EUR';
  }

  function setButtonState(button, state) {
    if (!button) return;

    if (state === 'loading') {
      button.disabled = true;
      button.classList.add('is-loading');
      button.classList.remove('is-added', 'is-error');
      button.textContent = 'Wird hinzugefügt…';
      return;
    }

    if (state === 'added') {
      button.disabled = true;
      button.classList.remove('is-loading', 'is-error');
      button.classList.add('is-added');
      button.textContent = 'Hinzugefügt ✓';
      return;
    }

    if (state === 'error') {
      button.disabled = false;
      button.classList.remove('is-loading', 'is-added');
      button.classList.add('is-error');
      button.textContent = 'Erneut versuchen';
      return;
    }

    button.disabled = false;
    button.classList.remove('is-loading', 'is-added', 'is-error');
    button.textContent = '+ Hinzufügen';
  }

  function updateCartCount(itemCount) {
    document.querySelectorAll(SELECTORS.cartCount).forEach((element) => {
      if (!element) return;

      element.hidden = itemCount <= 0;

      const innerCount = element.querySelector('[aria-hidden="true"], span');
      if (innerCount && innerCount !== element) {
        innerCount.textContent = itemCount;
      } else {
        element.textContent = itemCount;
      }
    });
  }

  function updateCartTotals(cart) {
    const formattedTotal = formatMoney(cart.total_price);

    document.querySelectorAll(SELECTORS.sidebarSubtotal).forEach((element) => {
      element.textContent = formattedTotal;
    });

    document.querySelectorAll(SELECTORS.stickySubtotal).forEach((element) => {
      element.textContent = formattedTotal;
    });
  }

  function replaceElementFromHtml(doc, selector) {
    const current = document.querySelector(selector);
    const fresh = doc.querySelector(selector);

    if (current && fresh) {
      current.replaceWith(fresh);
    }
  }

  async function refreshCartHtml() {
    const response = await fetch(window.location.pathname + '?_=' + Date.now(), {
        method: 'GET',
        credentials: 'same-origin',
        headers: {
        'Accept': 'text/html'
        }
    });

    if (!response.ok) return;

    const html = await response.text();
    const doc = new DOMParser().parseFromString(html, 'text/html');

    /* Wichtig:
        Cart-Form/Product-Liste NICHT ersetzen,
        sonst sortiert Shopify die Produkte optisch neu.
    */
    replaceElementFromHtml(doc, SELECTORS.mobilePreview);
    replaceElementFromHtml(doc, SELECTORS.cartSidebar);
    replaceElementFromHtml(doc, SELECTORS.stickyCheckout);
    }

  async function getCart() {
    const response = await fetch('/cart.js', {
      method: 'GET',
      credentials: 'same-origin',
      headers: {
        'Accept': 'application/json'
      }
    });

    if (!response.ok) {
      throw new Error('Cart konnte nicht geladen werden.');
    }

    return response.json();
  }

  async function addToCart(form) {
    const response = await fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Accept': 'application/json'
      },
      body: new FormData(form)
    });

    const data = await response.json();

    if (!response.ok) {
      throw new Error(data.description || data.message || 'Produkt konnte nicht hinzugefügt werden.');
    }

    return data;
  }

  document.addEventListener('submit', async function (event) {
    const form = event.target.closest(SELECTORS.upsellForm);

    if (!form) return;

    event.preventDefault();

    const button = form.querySelector('button[type="submit"]');
    const card = form.closest(SELECTORS.upsellCard);

    setButtonState(button, 'loading');

    try {
      await addToCart(form);

      const cart = await getCart();

      updateCartCount(cart.item_count);
      updateCartTotals(cart);

      await refreshCartHtml();

      if (card) {
        card.classList.add('is-added');
      }

      setButtonState(button, 'added');
    } catch (error) {
      console.warn(error);
      setButtonState(button, 'error');
    }
  });
})();